import script from "./HistoryFlatTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryFlatTable.vue?vue&type=script&setup=true&lang=js"

import "./HistoryFlatTable.vue?vue&type=style&index=0&id=b0e907ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e907ca"]])

export default __exports__